/** @format */

export const NOTIFICATION_TYPES = {
  PAYMENT: 'payment',
  SHIPMENT: 'shipment', 
  ACCOUNT: 'account'
};

export const getNotificationRoute = (type, data = {}) => {
  switch (type) {
    case NOTIFICATION_TYPES.PAYMENT:
      return '/payments';
    case NOTIFICATION_TYPES.SHIPMENT:
      return data.shipmentId ? `/shipments/${data.shipmentId}` : '/shipments';
    case NOTIFICATION_TYPES.ACCOUNT:
      return '/settings';
    default:
      return '/';
  }
};